// extracted by mini-css-extract-plugin
export var wrapper = "SvgImage-module--wrapper--3RMKj";
export var image = "SvgImage-module--image--3I7zr";